import { createContext, useContext, useState } from 'react'
import { AuthContext } from './AuthContext'
import axiosGet from '../Global/Axios/axiosGet'
import axiosPost from '../Global/Axios/axiosPost'
import handleError from '../Global/HandleError/handleError'
import { useSnackbar } from 'notistack'

export const DemoContext = createContext({
  demos: [],
  fetchDemos: () => {},
  getDemoById: (id: String): any => {},
  GetDemoRecordigns: (id: String): any => {},
})

const DemoContextProvider = (props: any) => {
  const { getAuthHeader, isLoggedIn, authState } = useContext(AuthContext)
  const [demos, setDemos] = useState([])
  const [demoDetails, setDemoDetails] = useState({})
  const { enqueueSnackbar } = useSnackbar()

  const fetchDemos = async () => {
    try {
      const res = await axiosGet(`/parent-demo/`, {
        headers: getAuthHeader(),
      })
      setDemos(res.data.results)
    } catch (error) {
      handleError(enqueueSnackbar, error)
    }
  }

  const getDemoById = async (demoId: String) => {
    try {
      return await axiosGet(`/parent-demo/${demoId}`, {
        headers: getAuthHeader(),
      })
    } catch (err) {
      console.log(err)
    }
  }

  const GetDemoRecordigns = async (demoId: String) => {
    try {
      return await axiosGet(`/parent-demo/${demoId}/download-files/`, {
        headers: getAuthHeader(),
      })
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <DemoContext.Provider
      value={{ demos, fetchDemos, getDemoById, GetDemoRecordigns }}
    >
      {props.children}
    </DemoContext.Provider>
  )
}

export default DemoContextProvider
